import { create } from 'zustand';
import { supabase } from '../lib/supabase';
import type { Profile } from './authStore';

interface UsersState {
  users: Profile[];
  isLoading: boolean;
  error: string | null;

  fetchUsers: () => Promise<void>;
}

export const useUsersStore = create<UsersState>((set) => ({
  users: [],
  isLoading: false,
  error: null,

  fetchUsers: async () => {
    set({ isLoading: true, error: null });
    const { data, error } = await supabase
      .from('profiles')
      .select('id, display_name')
      .order('display_name', { ascending: true });

    if (error) {
      set({ isLoading: false, error: error.message });
      return;
    }

    const users: Profile[] = (data ?? []).map(row => ({
      id: row.id,
      displayName: row.display_name,
    }));
    set({ users, isLoading: false });
  },
}));
